module.exports = __webpack_public_path__ + "img/report_icon.71289ed6.svg";